import Css from "./style.module.scss";

import ConfidencePercents from "nlib/common/ConfidencePercents";
import Constants from "const/Constants";
import DocumentContext from "contexts/DocumentContext";
import Numbers from "utils/Numbers";
import Objects from "utils/Objects";
import React, { useContext } from "react";

const Confidence = ({ fieldsNames = [], useMax = false }) => {
  const fieldsNamesArray = Array.isArray(fieldsNames) ? fieldsNames : [fieldsNames];

  const { recogniseData: { confidence = {} } } = useContext(DocumentContext);

  const fieldsValues = fieldsNamesArray.map((value) => Objects.getPropertyByPath(confidence, value) || 0);

  const confidenceValue = useMax ? Math.max(...fieldsValues) : Numbers.getAverageNumber(fieldsValues);

  if (!Math.floor(confidenceValue * Constants.PERCENTS_MULTIPLIER)) return null;

  return (
    <div className={Css.confidence}>
      <ConfidencePercents reverseColors value={confidenceValue} />
    </div>
  );
};

export default React.memo(Confidence);
